const baseCarousel = {
  default: {
    background: 'white',
    borderRadius: 'textOnly',
    borderWidth: '2px 2px 2px 24px',
    borderStyle: 'solid',
    borderColor: 'orange.45',
    minWidth: '356px',
    minHeight: '92px',
    boxShadow: 'cardTextOnly',
  },
  imageWithText: {
    background: 'white',
    borderRadius: 'card',
    minWidth: '220px',
    minHeight: '172px',
    boxShadow: 'cardList',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

const carousel = {
  products: {
    chart: baseCarousel,
    chartblog: baseCarousel,
    co: baseCarousel,
    edu: baseCarousel,
    scale: baseCarousel,
    spark: baseCarousel,
  },
};

export type CardCarouselVariantsType = 'default' | 'imageWithText';
export const cardCarouselVariants = Object.keys(baseCarousel) as CardCarouselVariantsType[];

export default carousel;
